import {
  accountApi,
  accreditationApi,
  businessApi,
  assetApi,
  marketingApi,
  authApi,
  clientApi,
  companyApi,
  linksAndDocumentsApi,
  termsAndConditionsApi,
  networkApi,
  operatorApi,
  tripApi,
  qrApi,
  ratingApi,
  reportingApi,
  reportApi,
  documentApi,
  resourceApi,
  userAccountApi,
  userAccountProfileApi,
  configVehicleApi,
  recommendApi,
  profileApi,
  notificationApi,
  typeaheadApi,
  systemApi,
  driverApi,
  driverProfileApi,
  driverPayoutApi,
  blockApi,
  bookingApi,
  externalSupplierApi,
  bookingOfferApi,
  paymentApi,
  payInvoiceApi,
  vehicleGuestApi,
  addOnApi,
  contentApi,
  jobRatingApi,
  paymentMethodApi,
  vehicleTypeApi,
  bankAccountApi,
  applicationApi,
  onboardingApi,
  subscriptionPlansApi,
  kycApi,
  clientBookingApi,
  clientDispatchApi,
  clientFlightApi,
  clientPoiApi,
  clientPaymentApi,
  providerPoiApi,
  clientProfileApi,
  clientAdminSettingsApi,
  favouritePassengerApi,
  clientReceiptsApi,
  assistantsApi,
} from "./apis";
import { bulkInviteClientApi } from "./apis/client/clientApi";
import { bulkInviteDriverApi } from "./apis/driver/driverApi";
import { guestApi } from "./apis/guest/guestApi";
import { vehicleApi } from "./apis/vehicle/vehicleApi";

export const middlewares = [
  authApi.middleware,
  accountApi.middleware,
  kycApi.middleware,
  tripApi.middleware,
  operatorApi.middleware,
  businessApi.middleware,
  configVehicleApi.middleware,
  assetApi.middleware,
  marketingApi.middleware,
  linksAndDocumentsApi.middleware,
  termsAndConditionsApi.middleware,
  qrApi.middleware,
  accreditationApi.middleware,
  resourceApi.middleware,
  userAccountApi.middleware,
  userAccountProfileApi.middleware,
  ratingApi.middleware,
  companyApi.middleware,
  reportingApi.middleware,
  reportApi.middleware,
  documentApi.middleware,
  networkApi.middleware,
  clientApi.middleware,
  bulkInviteClientApi.middleware,
  bulkInviteDriverApi.middleware,
  recommendApi.middleware,
  profileApi.middleware,
  notificationApi.middleware,
  typeaheadApi.middleware,
  systemApi.middleware,
  driverApi.middleware,
  driverProfileApi.middleware,
  driverPayoutApi.middleware,
  blockApi.middleware,
  bookingApi.middleware,
  externalSupplierApi.middleware,
  bookingOfferApi.middleware,
  paymentApi.middleware,
  payInvoiceApi.middleware,
  vehicleGuestApi.middleware,
  addOnApi.middleware,
  guestApi.middleware,
  vehicleApi.middleware,
  contentApi.middleware,
  jobRatingApi.middleware,
  paymentMethodApi.middleware,
  vehicleTypeApi.middleware,
  bankAccountApi.middleware,
  applicationApi.middleware,
  onboardingApi.middleware,
  subscriptionPlansApi.middleware,
  clientBookingApi.middleware,
  clientDispatchApi.middleware,
  clientFlightApi.middleware,
  clientPoiApi.middleware,
  clientPaymentApi.middleware,
  providerPoiApi.middleware,
  clientProfileApi.middleware,
  clientAdminSettingsApi.middleware,
  favouritePassengerApi.middleware,
  clientReceiptsApi.middleware,
  assistantsApi.middleware,
];
